import {
  citationsBottomSection,
  citationsTitle,
  createCitations,
  plagiarismBottomSection,
  plagiarismTitle,
  waBottomSection,
  writingAssistantTitle,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { CM_PRODUCT_NAME, EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'

export const EDITOR_WORD_LIMIT = 2500

export const NOT_READY = 'Not ready'
export const NEEDS_TWEAKS = 'Needs tweaks'
export const ALL_SET = 'All set!'

export const WRITING_GIF_HEIGHT = 250
export const WRITING_GIF_WIDTH = 250
export const SMALL_WRITING_GIF_HEIGHT = 176
export const SMALL_WRITING_GIF_WIDTH = 188
export const DEBOUNCE_SAVE_PAPER_TIME_PERIOD = 2000
export const WORDS = 'words'
export const UNTITLED = 'Untitled'
export const REVIEW = 'Review'
export const GET_STARTED = 'get started'
export const DISCLAIMER_TEXT = `This AI-powered tool offers writing enhancement suggestions, but may not be perfect or suitable for all contexts. Please review output carefully. Built with Meta Llama 3 and governed by Chegg’s `
export enum FeedbackTab {
  NO_ACTIVE_TAB = -1,
  GRAMMAR_TAB = 0,
  PARAPHRASE_TAB = 1,
}
export const RESOURCE_TEXT =
  'Our citation guides include clear examples and steps in formatting your paper, annotated bibliographies, works cited, and full or in-text citations.'

// timeout in milliseconds
export const FULL_CHECK_TIMEOUT = 180000
export const SELECTION_CHECK_TIMEOUT = 60000
export const CLARITY_FEEDBACK_REASON_TIMEOUT = 60000

export const QA_WORD_COUNT_LIMIT = 4 // synonym & rewrite word count limit

export const SENTENCE_FETCH_RETRY_COUNT = 2
export const SYNONYM_REWRITE_FETCH_RETRY_COUNT = 2
export const CLARITY_FEEDBACK_REASON_FETCH_RETRY_COUNT = 2
export const RESULT_MISMATCH_REWRITE_COUNT = 2

// testIds
export const ADD_SUGGESTION_TEXT = 'grammar-add-suggestion-text-test-id'
export const REWRITE_PANEL_TEST_ID = 'wa-rewrite-panel'
export const EMPTY_SUGGESTIONS_CARD_TEST_ID = 'wa-empty-suggestions-card'
export const CLARITY_CARD_TEST_ID = 'wa-clarity-card'
export const CLARITY_CARD_REASON_TEST_ID = 'wa-clarity-card-reason'
export const GRAMMAR_CARD_TEST_ID = 'wa-grammar-card'
export const EDITOR_FOOTER_TEST_ID = 'wa-editor-footer'
export const EDITOR_HEADER_TEST_ID = 'wa-editor-header'
export const EDITOR_WRAPPER_TEST_ID = 'wa-editor-wrapper'
export const ENTRY_BANNER_TEST_ID = 'wa-entry-banner'
export const PROGRESS_LINE_TEST_ID = 'wa-progress-line-score'
export const INFOTOOLTIP_TEST_ID = 'wa-info-tool-tip'
export const PROOFREADER_LEFT_PANEL_TEST_ID = 'wa-proofreader-left-panel'
export const CARD_IMAGE_CAROUSEL_TEST_ID = 'wa-card-image-carousel'
export const IMAGE_CAROUSEL_TEST_ID = 'wa-image-carousel'
export const SHIMMER_REWRITE_TEST_ID = 'wa-shimmer-rewrite'
export const WRITING_ASSISTANT_BANNER = 'writing-assistant-info-banner'
export const CITATION_GENERATOR_BANNER = 'citation-generatore-info-banner'
export const PLAGIARISM_CHECKER_BANNER = 'plagiarism-checker-info-banner'
// testIds end

export const HOMEPAGE_PRIMARY_HEADING = 'Get your paper hand-in ready'

export const MAXIMUM_DEPTH_OF_HISTORY = 50
export const DEBOUNCE_HISTORY_VERSION_TIME_PERIOD = 200

export const CLARITY_CARD_REASON_TITLE = 'Learn why'

export const EDITOR_TOOLBAR_TEST_ID = 'editor-toolbar'

export const homepageCtaMapCardImage = {
  'polish-writing': {
    name: GET_STARTED,
    region: writingAssistantTitle,
  },
  'create-citations': {
    name: createCitations,
    region: citationsTitle,
  },
  'check-paper': {
    name: 'scan paper',
    region: plagiarismTitle,
  },
}

export const homepageCtaMapBannerText = {
  'writing-assistant-text-content': {
    name: GET_STARTED,
    region: waBottomSection,
  },
  'citation-generator-text-content': {
    name: GET_STARTED,
    region: citationsBottomSection,
  },
  'plagiarism-checker-text-content': {
    name: GET_STARTED,
    region: plagiarismBottomSection,
  },
}

export const RESOURCE_TITLES = {
  [EB_PRODUCT_NAME]: 'EasyBib Resources',
  [CM_PRODUCT_NAME]: 'Citation Machine® Guides & Resources',
}
